<ng-select
  [id]="id"
  [items]="getFilteredItems()"
  [clearable]="allowClear"
  (change)="selected($event)"
  (remove)="removed()"
  [placeholder]="placeholder"
  [ngClass]="ngClass"
  [multiple]="multiple"
  bindLabel="text"
  bindValue="id"
  [(ngModel)]="activeIds"
  class="appSelect"
  [disabled]="disabled"
  [appendTo]="appendTo"
>
</ng-select>
